import {
    Image,
    useAppDisplayModeContext,
    useStyles,
    Flex,
    Subheader,
    useTheme,
} from '@archipro-design/aria';

import * as S from './AboutBanner.style';
import { pxToRem } from '@archipro-design/aria';

import {
    ABOUT_BANNER_SIZE,
    ABOUT_BANNER_SIZE_MOBILE,
} from '@modules/professional/config/constants';
import { getImagesSizes } from '~/utils/image-sizes-utils';

interface AboutBannerProps {
    bannerImage: string | null;
    title: string;
}
export const AboutBanner: React.FC<AboutBannerProps> = ({
    bannerImage,
    title,
}) => {
    const theme = useTheme();
    const { mobile: isMobile } = useAppDisplayModeContext();

    const { css } = useStyles();

    const bannerSize = isMobile ? ABOUT_BANNER_SIZE_MOBILE : ABOUT_BANNER_SIZE;

    return bannerImage ? (
        <div className={css(S.Banner)}>
            <Image
                src={bannerImage}
                width={pxToRem(bannerSize)}
                height={pxToRem(bannerSize)}
                layout={`fill`}
                objectFit={`cover`}
                sizes={getImagesSizes({
                    desktop: ABOUT_BANNER_SIZE,
                    mobile: ABOUT_BANNER_SIZE_MOBILE,
                })}
                alt={`${title}`}
            />
        </div>
    ) : (
        <Flex className={css(S.Banner)} hAlign="center" vAlign="center">
            <Subheader
                variant="03"
                variables={{
                    color: theme.siteVariables.colors.grey['300'],
                }}
            >
                About image
            </Subheader>
        </Flex>
    );
};
